export default __webpack_public_path__ + "static/media/tungu-verifiakasi.0365c9fb.svg";